'use strict';

import {cardsData, isDesktop, isMobile, settingsData} from "../../settings";
import { addStatisticTimeOut, closeNotifications, createPopUp } from './statistic';
import Notiflix from 'notiflix';
import { getCurrentLangDirection} from '../components/langSwitcher/langSwitcher';
import { Cookie } from '../Cookie/Cookie';

export const conferenceStatistic = (args) => {
    const { cardBox, object } = args;

    if (isMobile || cardsData.cardMode.isAmenities || cardsData.cardMode.isUnavailable)
        return;

    if (!cardBox)
        return;

    let statisticCnt;

    if (typeof window.localStorage !== 'undefined' ) {
        statisticCnt = JSON.parse(localStorage.getItem('statisticCnt'))?.[object.engineId];
    } else {
        statisticCnt = Cookie.getCookie('statisticCnt')?.[object.engineId];
    }

    let statisticData;

    if (!statisticCnt) {
        statisticData = setStatisticToStorage();
    } else {
        statisticData = getStatisticFromStorage();
    }

    const {statisticInterestedBlock, statisticFavoritesBlock, statisticBlock} = createPopUp();
    statisticInterestedBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${statisticData.interestCntValue}</span>`);
    statisticFavoritesBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${statisticData.favoritesCntValue}</span>`);
    const copyInterested = statisticBlock.cloneNode(true);
    const copyFavorite = statisticBlock.cloneNode(true);
    const dir = getCurrentLangDirection();

    copyInterested.appendChild(statisticInterestedBlock);
    copyFavorite.appendChild(statisticFavoritesBlock);

    Notiflix.Notify.merge({
        position: isDesktop ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr')
    })

    Notiflix.Notify.info(`${copyInterested.innerHTML}`);
    const timeout = setTimeout(()=> Notiflix.Notify.info(`${copyFavorite.innerHTML}`),1000);
    addStatisticTimeOut(timeout);
}

const setStatisticToStorage = (timeFlag) => {
    const now = new Date();
    const apt = settingsData.lastClickedFlat.userData.crm_data.engineId;
    const newObject = {
        'interestCntValue': Math.floor(Math.random() * 50) + 1,
        'favoritesCntValue': Math.floor(Math.random() * 30) + 1,
        'expiry': now.getTime(),
    }
    let object;
    let storageData;

    if (typeof window.localStorage !== 'undefined' ) {
        storageData = JSON.parse(localStorage.getItem('statisticCnt'));
    } else {
        storageData = JSON.parse(Cookie.getCookie('statisticCnt'));
        
    }

    if (!storageData) {
        if (typeof window.localStorage !== 'undefined' ) {
            localStorage.setItem('statisticCnt', JSON.stringify({
                [apt]: newObject,
            }))
        } else {
            Cookie.setCookie('statisticCnt',JSON.stringify({
                [apt]: newObject,
            }));
        }
        object = newObject;
        return object;
    } else if (!storageData[apt] || timeFlag) {
        if (typeof window.localStorage !== 'undefined' ) {
            localStorage.setItem('statisticCnt', JSON.stringify({
                ...storageData, [apt]: newObject,
            }))
        } else {
            Cookie.setCookie('statisticCnt',JSON.stringify({
                ...storageData, [apt]: newObject,
            }));
        }
        object = newObject;
        return object;
    } else {
        object = storageData[apt];
        return object;
    }
}

const getStatisticFromStorage = () => {
    let statisticCnt;
    if (typeof window.localStorage !== 'undefined' ) {
        statisticCnt = JSON.parse(localStorage.getItem('statisticCnt'));
    } else {
        statisticCnt = Cookie.getCookie('statisticCnt');
    }

    const apt = settingsData.lastClickedFlat.userData.crm_data.engineId;

    if (!statisticCnt)
        return null;

    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;

    if (now.getTime() - statisticCnt[apt].expiry > oneDay) {
        return setStatisticToStorage('timeOver');
    } else {
        return statisticCnt[apt];
    }
}

